import angular from 'angular';
import XLSX from 'xlsx';
import { ISaldoInicialImportacaoArquivo, ISaldoInicialRow } from '../../models/saldo-inicial.model';

const CABECALHO_MODELO = ['Matricula', 'Nome', 'CPF', 'Saldo (minutos)'];

export class SaldoInicialImportarModalController {
    static $inject = [
        '$uibModalInstance',
        '$scope',
        'entity',
        'entities',
        'NewToaster'
    ];

    public form: angular.IFormController;
    public isFileValid = false;

    constructor(
        public $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        public $scope: angular.IScope,
        public entity: ISaldoInicialImportacaoArquivo,
        public entities: ISaldoInicialRow[],
        public NewToaster: { pop: Function }
    ) {}

    fileTypeValidation() {
        if (!this.entity.file || !this.entity.file[0]) {
            this.isFileValid = false;
            this.$scope.$applyAsync();
            return;
        }

        const allowedExtensions = /\.(xlsx|csv)$/i;
        if (!allowedExtensions.exec(this.entity.file[0].name)) {
            this.NewToaster.pop({
                type: 'error',
                title: 'Tipo de arquivo inválido',
                body: 'O tipo do arquivo deve ser .csv ou .xlsx',
            });
            this.isFileValid = false;
            this.entity.file = {} as FileList;
        } else {
            this.isFileValid = true;
        }

        this.$scope.$applyAsync();
    }

    formatBytes(bytes: number, decimals: number = 2) {
        if (bytes === 0) {
            return '0 Bytes';
        }

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    submit() {
        if (!this.isFileValid || this.form.$invalid) {
            return;
        }

        this.$uibModalInstance.close(this.entity);
    }

    close() {
        this.$uibModalInstance.dismiss('cancelar');
    }

    baixarModeloCsv() {
        const linhas = [CABECALHO_MODELO, ...this.montarLinhasModelo()]
            .map((linha) => linha.map((valor) => this.escaparCampoCsv(valor)).join(';'))
            .join('\r\n');

        const blob = new Blob(['﻿' + linhas], { type: 'text/csv;charset=utf-8;' });
        this.baixarBlob(blob, 'planilha_modelo_saldo_inicial.csv');
    }

    baixarModeloXlsx() {
        const worksheet = XLSX.utils.aoa_to_sheet([CABECALHO_MODELO, ...this.montarLinhasModelo()]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Saldo inicial');

        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([wbout], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        this.baixarBlob(blob, 'planilha_modelo_saldo_inicial.xlsx');
    }

    private montarLinhasModelo(): (string | number)[][] {
        return (this.entities || []).map((entity) => [
            entity.codigo,
            entity.nome,
            entity.cpf,
            entity.saldo,
        ]);
    }

    private escaparCampoCsv(valor: string | number) {
        const texto = String(valor ?? '');

        if (/[;"\r\n]/.test(texto)) {
            return `"${texto.replace(/"/g, '""')}"`;
        }

        return texto;
    }

    private baixarBlob(blob: Blob, fileName: string) {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);
    }
}
